import * as DEV_ENV from './env';
import * as PROD_ENV from './env.prod';
const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
export default env !== 'production' ? DEV_ENV : PROD_ENV;
